export default "__VITE_ASSET__DXLfhkDb__"